import { HeaderGroup } from "@tanstack/react-table";
import { RefObject, useRef } from "react";

import { TableData } from "../table";
import { FixedTableHeader } from "./fixed_table_header";
import { TableHeaderRows } from "./table_header_rows";

type TableHeaderProps<T extends TableData> = {
  headerGroups: HeaderGroup<T>[];
  compact?: boolean;
  displayGrid?: boolean;
  enableMultiRowSelection?: boolean;
  enableFixedHeader?: boolean;
  tableClassName?: string;
  tableRef?: RefObject<HTMLTableElement | null>;
  scrollContainerRef?: RefObject<HTMLElement | null>;
  getFixedHeaderWrapperStyle?: () => Partial<CSSStyleDeclaration> | undefined;
};

export const TableHeader = <TABLE_DATA extends TableData>({
  headerGroups,
  compact,
  displayGrid,
  enableMultiRowSelection,
  enableFixedHeader,
  tableClassName,
  tableRef,
  scrollContainerRef,
  getFixedHeaderWrapperStyle
}: TableHeaderProps<TABLE_DATA>) => {
  const theadRef = useRef<HTMLTableSectionElement>(null);

  return (
    <>
      <TableHeaderRows
        theadRef={theadRef}
        headerGroups={headerGroups}
        compact={compact}
        displayGrid={displayGrid}
        enableMultiRowSelection={enableMultiRowSelection}
      />
      {enableFixedHeader && (
        <FixedTableHeader
          realTheadRef={theadRef}
          tableRef={tableRef}
          scrollContainerRef={scrollContainerRef}
          getWrapperStyle={getFixedHeaderWrapperStyle}
          headerGroups={headerGroups}
          compact={compact}
          displayGrid={displayGrid}
          enableMultiRowSelection={enableMultiRowSelection}
          tableClassName={tableClassName}
        />
      )}
    </>
  );
};
